<script>
	import { onDestroy, onMount, tick } from "svelte";
	import { PRConnect } from "@projectroom/ui-lib";
	import { planStore } from "./store/plan-store";
	import { navigateTo } from "svelte-router-spa";
	import Swiper from "swiper/bundle";
	import { fade } from "svelte/transition";
	import { isDarkMode } from "./store/theme-store.js";
	// import Swiper styles
	// import 'swiper/css';

	let chatList = [];
	let chatListWeekly = [];
	let chatListTotal = [];
	let chatListAdminObj = {};
	let chatListNewest = [];
	let categoryList = [];
	let filteredList = chatList;
	let activeFilter = "전체";
	let sortOption = "popularity"; // 기본 정렬 방식
	let selectedChat = null;
	let isAIChatPopup;
	let isBottomRise = true;
	let aiChatUrl;
	let isMobile = false;
	let isLoggedIn = false;
	let chatSortOption = "weekly";
	let isLoaded = false;
	let currentTab = "priority";

	onMount(() => {
		isLoggedIn = planStore.isLoggedIn();
		getChatList();
		checkMobile();
		window.addEventListener("resize", checkMobile);
		isDarkMode.update(() => true);
	});

	onDestroy(() => {
		window.removeEventListener("resize", checkMobile);
	});

	// 반응형 변수: 정렬과 필터링 적용된 리스트
	$: filteredList = chatList
		.filter(
			(chat) =>
				activeFilter === "전체" || chat.categoryName === activeFilter,
		)
		.sort((a, b) => {
			if (sortOption === "popularity") {
				return b.chatCount - a.chatCount;
			} else if (sortOption === "newest") {
				return new Date(b.creationDate) - new Date(a.creationDate);
			}
			return 0;
		});

	const getChatList = () => {
		PRConnect.send("/api/Chat/getChatListForMain", {}, async (data) => {
			if (data.header.status === "success") {
				chatList = data.result.chatList;
				chatListWeekly = data.result.chatListWeekly;
				chatListTotal = data.result.chatListTotal;
				chatListAdminObj = data.result.chatListAdmin.reduce(
					(acc, chat) => {
						if (!acc[chat.categoryId]) {
							acc[chat.categoryId] = [];
						}
						acc[chat.categoryId].push(chat);
						return acc;
					},
					{},
				);
				chatListNewest = data.result.chatListNewest;
				chatList = data.result.chatList;
				categoryList = data.result.categoryList;
				isLoaded = true;
				await tick();
				setUpSwiper(".chat-weekly");
				setUpSwiper(".chat-total");
				setUpSwiper(".chat-newest", { loop: true });
				setUpSwiper(".chat-category", {
					slidesPerView: "auto",
					spaceBetween: 6,
					loop: false,
					breakpoints: {
						768: {
							slidesPerView: "auto",
							spaceBetween: 8,
						},
						1024: {
							slidesPerView: "auto",
							spaceBetween: 12,
						},
					},
				});
				Object.entries(chatListAdminObj).forEach(([key, value]) => {
					setUpSwiper(`.chat-admin-${key}`, { loop: true });
				});
			}
		});
	};

	// 정렬 방식 설정 함수
	const setSortOption = (option) => {
		sortOption = option;
	};

	const setFilter = (filter) => {
		activeFilter = filter;
	};

	const selectChat = (chat) => {
		selectedChat = chat;
		isAIChatPopup = true;
	};

	const closeAIChatPopup = () => {
		isAIChatPopup = false;
		isBottomRise = true;
		selectedChat = null;
		aiChatUrl = null;
	};

	const clickConversationStart = (chat) => {
		if (isMobile) {
			window.open(`/chat/${chat.id}?preview=none`, "_blank");
		} else {
			aiChatUrl = `/chat/${chat.id}?story=none`;
			isBottomRise = false;
		}
	};

	const checkMobile = () => {
		isMobile = window.matchMedia("(max-width: 768px)").matches; // 화면 너비가 768px 이하일 때 모바일로 간주
	};

	const clickCreateChat = () => {
		if (isLoggedIn) {
			PRConnect.send("/api/Chat/createChat", {}, (data) => {
				if (data.header.status === "success") {
					navigateTo(`/chat-builder/${data.result}`);
				}
			});
		} else {
			navigateTo("/login");
		}
	};

	const convertUrlsToLinks = (text) => {
		if (text === undefined) return "";

		const urlRegex = /(https?:\/\/[^\s<)]+)/g;
		return text.replace(urlRegex, (url) => {
			return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
		});
	};

	const formatNumber = (number) => {
		if (!number) {
			return "0";
		}
		if (number < 1000) {
			return number.toString();
		} else if (number < 10000) {
			return (number / 1000).toFixed(1) + "천";
		} else if (number < 100000000) {
			return number % 10000 === 0
				? number / 10000 + "만"
				: (number / 10000).toFixed(1) + "만";
		} else {
			return (number / 100000000).toFixed(1) + "억";
		}
	};

	const setUpSwiper = (target, options = {}) => {
		const defaultOptions = {
			loop: false,
			slidesPerView: 2.25,
			spaceBetween: 12,
			breakpoints: {
				768: {
					slidesPerView: 3.25,
					spaceBetween: 18,
				},
				1024: {
					slidesPerView: 4.25,
					spaceBetween: 26,
				},
			},
		};

		const config = { ...defaultOptions, ...options };

		const swiper = new Swiper(target, {
			direction: "horizontal",
			loop: config.loop,
			slidesPerView: config.slidesPerView,
			spaceBetween: config.spaceBetween,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: config.breakpoints,
		});
	};

	const checkEmptyImage = (chat) => {
		if (!chat.profileImageContent) {
			return "/static/images/empty-profile-image.png";
		}
		return chat.profileImageContent;
	};

	const clickChangeThema = () => {
		isDarkMode.update((value) => !value);
	};
</script>

{#if selectedChat}
	<div class="chat-introduction-popup-wrapper" on:click={closeAIChatPopup}>
		<div class="chat-introduction-popup" class:show={isAIChatPopup}>
			<div
				class="ai-chat-con"
				class:bottom-rise={isBottomRise}
				on:click|stopPropagation
			>
				<div class="ai-chat-wrapper">
					<div class="ai-chat-image">
						<img
							src={selectedChat.profileImageContent}
							loading="lazy"
							alt=""
							class="image-178"
						/>
					</div>
					<div class="ai-chat-name">
						<div class="ai-name _2">{selectedChat.title}</div>
						<div class="pingpong2">
							<img
								src="/static/images/ava-logo_1ava-logo.png"
								loading="lazy"
								alt=""
								class="image-174"
							/>
							<div class="text-block-141">
								{selectedChat.chatCount}
							</div>
						</div>
					</div>
					<div class="ai-chat-text">
						<div class="introduction-text">
							<div class="chat-intro-title">캐릭터 소개</div>
							<div class="chat-intro-content">
								{@html convertUrlsToLinks(
									selectedChat.subTitle?.replace(
										/\n/g,
										"<br>",
									),
								)}
							</div>
							<div class="more-text">
								<img
									src="/static/images/more-icon.svg"
									loading="lazy"
									alt=""
								/>
							</div>
						</div>
					</div>
					<div class="ai-chat-text">
						<div class="introduction-text">
							<div class="chat-intro-title">캐릭터 세계관</div>
							<div class="chat-intro-content">
								{@html convertUrlsToLinks(
									selectedChat.characterUniverse?.replace(
										/\n/g,
										"<br>",
									),
								)}
							</div>
							<div class="more-text">
								<img
									src="/static/images/more-icon.svg"
									loading="lazy"
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="conversation-bottom">
					<div
						class="conversation-btn"
						class:hide={aiChatUrl}
						on:click={() => clickConversationStart(selectedChat)}
					>
						<div>대화 시작하기</div>
					</div>
				</div>
				<div class="ai-x-button" on:click={closeAIChatPopup}></div>
				<!-- 닫기 버튼 -->
			</div>
			<div class="ai-chat-iframe-wrapper" class:show={aiChatUrl}>
				<iframe class="ai-chat-iframe" src={aiChatUrl}> </iframe>
			</div>
		</div>
	</div>
{/if}
<div class="a-contents-aichat">
	<div
		data-current="Tab 1"
		data-easing="ease"
		data-duration-in="300"
		data-duration-out="100"
		class="aichat-tab w-tabs"
	>
		<div class="event-title">
			<div class="e-title svelte-1f0cjdp">
				<strong class="bold-text-7">AI챗</strong>
			</div>
			<div class="toggle-wrapper">
				<span>Dark Mode</span>
				<div
					class="toggle-button _2"
					on:click={() => clickChangeThema()}
				>
					<div class="toggle" class:on={$isDarkMode}></div>
					<div class="toggle-round" class:on={$isDarkMode}></div>
				</div>
			</div>
		</div>
		<div class="tabs-wrapper">
			<div class="tabs-menu-4 w-tab-menu">
				<a
					data-w-tab="Tab 1"
					class="tab-link-tab-1-4 w-inline-block w-tab-link"
					class:w--current={currentTab == "priority"}
					on:click={() => (currentTab = "priority")}
				>
					<div class="text-block-139">추천</div>
				</a>
				<a
					data-w-tab="Tab 2"
					class="tab-link-tab-2-4 w-inline-block w-tab-link"
					class:w--current={currentTab == "category"}
					on:click={() => (currentTab = "category")}
				>
					<div class="text-block-140">카테고리</div>
				</a>
			</div>
			{#if currentTab === "category"}
				<div class="sort-optoins">
					<span
						class:sort-selected={sortOption !== "popularity"}
						on:click={() => setSortOption("popularity")}
						>인기순</span
					>
					<span class="divider">|</span>
					<span
						class:sort-selected={sortOption !== "newest"}
						on:click={() => setSortOption("newest")}>최신순</span
					>
				</div>
			{/if}
		</div>
		<div class="w-tab-content" in:fade>
			<div
				data-w-tab="Tab 1"
				class="w-tab-pane"
				class:w--tab-active={currentTab == "priority"}
			>
				{#if isLoaded}
					<div class="aichat-section interest-wrapper">
						<div class="sort-wrapper type2">
							<div class="aichat-text">인기 TOP10🔥</div>
							<div class="category-button">
								<div
									class="category-btn"
									class:gray={chatSortOption !== "weekly"}
									on:click={() => (chatSortOption = "weekly")}
								>
									<div
										class="text-block-141"
										class:gray={chatSortOption !== "weekly"}
									>
										주간
									</div>
								</div>
								<div
									class="category-btn"
									class:gray={chatSortOption !== "total"}
									on:click={() => (chatSortOption = "total")}
								>
									<div
										class="text-block-141"
										class:gray={chatSortOption !== "total"}
									>
										누적
									</div>
								</div>
							</div>
						</div>
						<div
							class="swiper chat-weekly"
							class:show={chatSortOption === "weekly"}
						>
							<div class="aichat-item-wrap swiper-wrapper">
								{#each chatListWeekly as chat, idx}
									<div
										class="ai-item swiper-slide"
										on:click={() => selectChat(chat)}
									>
										<div class="ai-thumbnail">
											<div class="rank">{idx + 1}</div>
											<img
												src={checkEmptyImage(chat)}
												loading="lazy"
												class="image-173"
											/>
											<div class="pingpong">
												<img
													src="/static/images/ava-logo_1ava-logo.png"
													loading="lazy"
													alt=""
													class="image-174"
												/>
												<div class="text-block-141">
													{formatNumber(
														chat.chatCount,
													)}
												</div>
											</div>
										</div>
										<div class="ai-name">{chat.title}</div>
										<div class="ai-contents">
											{#if chat.subTitle}
												{@html chat.subTitle.replace(
													/\n/g,
													"<br>",
												)}
											{/if}
										</div>
									</div>
								{/each}
							</div>
							<div class="swiper-button-prev"></div>
							<div class="swiper-button-next"></div>
						</div>
						<div
							class="swiper chat-total"
							class:show={chatSortOption === "total"}
						>
							<div class="aichat-item-wrap swiper-wrapper">
								{#each chatListTotal as chat}
									<div
										class="ai-item swiper-slide"
										on:click={() => selectChat(chat)}
									>
										<div class="ai-thumbnail">
											<div class="rank">
												{chat.ranking}
											</div>
											<img
												src={checkEmptyImage(chat)}
												loading="lazy"
												class="image-173"
											/>
											<div class="pingpong">
												<img
													src="/static/images/ava-logo_1ava-logo.png"
													loading="lazy"
													alt=""
													class="image-174"
												/>
												<div class="text-block-141">
													{formatNumber(
														chat.chatCount,
													)}
												</div>
											</div>
										</div>
										<div class="ai-name">{chat.title}</div>
										<div class="ai-contents">
											{#if chat.subTitle}
												{@html chat.subTitle.replace(
													/\n/g,
													"<br>",
												)}
											{/if}
										</div>
									</div>
								{/each}
							</div>
							<div class="swiper-button-prev"></div>
							<div class="swiper-button-next"></div>
						</div>
					</div>
					{#each Object.entries(chatListAdminObj) as [categoryId, chatList]}
						<div class="aichat-section">
							<div class="aichat-text">
								{chatList[0].categoryName}
							</div>
							<div class="swiper chat-admin-{categoryId}">
								<div class="aichat-item-wrap swiper-wrapper">
									{#each chatList as chat}
										<div
											class="ai-item swiper-slide"
											on:click={() => selectChat(chat)}
										>
											<div class="ai-thumbnail">
												<img
													src={checkEmptyImage(chat)}
													loading="lazy"
													width="200"
													alt=""
													class="image-173"
												/>
												<div class="pingpong">
													<img
														src="/static/images/ava-logo_1ava-logo.png"
														loading="lazy"
														alt=""
														class="image-174"
													/>
													<div class="text-block-141">
														{formatNumber(
															chat.chatCount,
														)}
													</div>
												</div>
											</div>
											<div class="ai-name">
												{chat.title}
											</div>
											<div class="ai-contents">
												{#if chat.subTitle}
													{@html chat.subTitle.replace(
														/\n/g,
														"<br>",
													)}
												{/if}
											</div>
										</div>
									{/each}
								</div>
								<div class="swiper-button-prev"></div>
								<div class="swiper-button-next"></div>
							</div>
						</div>
					{/each}
					<div class="aichat-section">
						<div class="aichat-text">
							따끈 따끈 지금 나온 신상 🎀
						</div>
						<div class="swiper chat-newest">
							<div class="aichat-item-wrap swiper-wrapper">
								{#each chatListNewest as chat}
									<div
										class="ai-item swiper-slide"
										on:click={() => selectChat(chat)}
									>
										<div class="ai-thumbnail">
											<img
												src={checkEmptyImage(chat)}
												loading="lazy"
												width="200"
												alt=""
												class="image-173"
											/>
											<div class="pingpong">
												<img
													src="/static/images/ava-logo_1ava-logo.png"
													loading="lazy"
													alt=""
													class="image-174"
												/>
												<div class="text-block-141">
													{formatNumber(
														chat.chatCount,
													)}
												</div>
											</div>
										</div>
										<div class="ai-name">{chat.title}</div>
										<div class="ai-contents">
											{#if chat.subTitle}
												{@html chat.subTitle.replace(
													/\n/g,
													"<br>",
												)}
											{/if}
										</div>
									</div>
								{/each}
							</div>
							<div class="swiper-button-prev"></div>
							<div class="swiper-button-next"></div>
						</div>
					</div>
				{/if}
			</div>
			<div
				data-w-tab="Tab 2"
				class="w-tab-pane"
				class:w--tab-active={currentTab == "category"}
			>
				{#if isLoaded}
					<div class="chat-category sort-wrapper swiper">
						<div class="category-button swiper-wrapper">
							<div
								class="category-btn swiper-slide"
								class:gray={activeFilter !== "전체"}
								on:click={() => setFilter("전체")}
							>
								<div
									class="text-block-141"
									class:gray={activeFilter !== "전체"}
								>
									전체
								</div>
							</div>
							{#each categoryList as category}
								<div
									class="category-btn swiper-slide"
									class:gray={activeFilter !== category.name}
									on:click={() => setFilter(category.name)}
								>
									<div
										class="text-block-141"
										class:gray={activeFilter !==
											category.name}
									>
										{category.name}
									</div>
								</div>
							{/each}
						</div>
						<div class="swiper-button-prev"></div>
						<div class="swiper-button-next"></div>
					</div>
					<div class="aichat-section">
						<div class="aichat-item-wrap">
							{#each filteredList as chat}
								<div
									class="ai-item"
									on:click={() => selectChat(chat)}
								>
									<div class="ai-thumbnail">
										<img
											src={checkEmptyImage(chat)}
											loading="lazy"
											width="200"
											alt=""
											class="image-173"
										/>
										<div class="pingpong">
											<img
												src="/static/images/chat-icon.svg"
												loading="lazy"
												alt=""
												class="image-174"
											/>
											<div class="text-block-141">
												{formatNumber(chat.chatCount)}
											</div>
										</div>
									</div>
									<div class="ai-name">
										{chat.title || "AI챗"}
									</div>
									<div class="ai-contents">
										{#if chat.subTitle}
											{@html chat.subTitle.replace(
												/\n/g,
												"<br>",
											)}
										{/if}
									</div>
								</div>
							{/each}
						</div>
					</div>
					<div class="aichat-section _2"></div>
				{/if}
			</div>
		</div>
	</div>
	<div class="ai-talk-builder" on:click={clickCreateChat}>
		<img
			src="/static/images/a-plus-btn.svg"
			loading="lazy"
			alt=""
			class="image-177"
		/>
		<div class="text-block-142">AI챗 제작</div>
	</div>
</div>

<style>
	.aichat-item-wrap {
		max-width: 100%;
		grid-column-gap: 32px;
	}

	.category-btn {
		cursor: pointer;
		margin-bottom: 12px;
	}
	.ai-item {
		cursor: pointer;
	}

	.ai-contents {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2; /* 원하는 줄 수로 설정 */
		-webkit-box-orient: vertical;
		white-space: normal;
	}

	.ai-chat-wrapper {
		min-height: -webkit-fill-available;
	}

	.chat-introduction-popup {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
	}

	.ai-chat-iframe-wrapper {
		width: 500px;
	}

	.ai-chat-iframe {
		width: 100%;
		height: 100%;
		border-width: 0px;
	}

	.ai-chat-iframe-wrapper {
		display: none;
	}

	.ai-chat-con {
		padding-top: 45px;
		padding-left: 45px;
		padding-right: 45px;
		height: calc(100vh - 112px);
	}

	.ai-chat-iframe {
		height: calc(100vh - 112px);
	}

	.ai-x-button {
		inset: 1.5% 4% auto auto;
		cursor: pointer;
	}

	.ai-chat-text {
		margin-bottom: 0px;
	}

	.chat-introduction-popup-wrapper {
		position: absolute;
		left: 0%;
		top: 0%;
		right: 0%;
		bottom: 0%;
		z-index: 999;
	}
	.chat-introduction-popup-wrapper:before {
		content: "";
		position: fixed;
		top: 72px;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.8);
	}

	.chat-wrapper {
		height: 94vh;
	}

	.swiper .aichat-item-wrap {
		grid-column-gap: 0;
	}

	.ai-thumbnail {
		aspect-ratio: 1 / 1;
		overflow: hidden;
		border-radius: 10px;
	}

	.swiper .ai-thumbnail {
		max-width: 290px;
		overflow: hidden;
		border-radius: 10px;
		position: relative;
	}

	.swiper .ai-thumbnail > img {
		max-width: 290px;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.conversation-bottom {
		position: fixed;
		inset: auto 0% 10%;
		left: 0;
		right: 0;
		bottom: 0;
		background: #fff;
		padding: 20px 45px 90px;
		border-top: 1px solid #e9e9e9;
	}
	.conversation-bottom .conversation-btn {
		position: relative;
		margin: 0;
	}
	.ai-chat-name {
		margin-top: 28px;
	}
	.bottom-rise {
		height: calc(100vh - 164px);
	}

	.aichat-tab {
		margin: auto;
	}

	.sort-wrapper {
		display: flex;
		justify-content: space-between; /* 좌우 끝으로 배치 */
		align-items: center; /* 세로 중앙 정렬 */
	}

	.sort-wrapper.type2 {
		justify-content: flex-start;
		gap: 20px;
	}

	.sort-wrapper.type2 .category-button {
		margin: 15px 0 0;
	}

	.sort-optoins {
		font-size: 18px;
		min-width: 120px;
		font-weight: 600;
	}

	.sort-optoins span {
		cursor: pointer;
	}

	.sort-selected {
		color: rgba(191, 189, 189, 1);
	}

	.divider {
		color: #e9e9e9; /* 구분선 색상 */
		padding: 0 4px; /* 좌우 여백 */
	}

	.pingpong {
		inset: unset;
		right: 10px;
		bottom: 10px;
	}

	.event-title {
		margin: auto;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px;
	}

	.e-title {
		margin-left: 0px;
		margin-bottom: 0px;
	}

	.a-contents-aichat {
		margin-top: 86px;
	}
	.aichat-tab {
		padding-top: 0px;
	}

	.aichat-tab {
		margin-left: 10px;
		margin-right: 10px;
	}

	.aichat-text {
		font-size: 24px;
	}

	.swiper {
		margin: 0;
	}

	.swiper-button-next:after,
	.swiper-button-prev:after {
		font-size: initial;
		color: white;
	}

	.swiper-button-next,
	.swiper-button-prev {
		top: var(--swiper-navigation-top-offset, 43%);
		width: 2rem;
		height: 2rem;
		background-color: rgba(0, 0, 0, 0.4);
	}
	.chat-category .swiper-button-next,
	.chat-category .swiper-button-prev {
		top: var(--swiper-navigation-top-offset, 73%);
	}

	.swiper-button-next:hover,
	.swiper-button-prev:hover {
		background-color: rgba(0, 0, 0, 0.6);
	}

	.rank {
		position: absolute;
		background-color: rgba(247, 82, 138, 1);
		color: #fff;
		font-size: 24px;
		padding: 10px 14px;
		border-radius: 10px 0px 10px 0px;
		font-weight: bold;
	}

	.interest-wrapper .swiper {
		display: none;
	}

	.interest-wrapper .swiper.show {
		display: flex;
	}

	.w-tab-content {
		min-height: 2000px;
	}

	.ai-item {
		min-width: 0;
	}

	.image-173 {
		height: 100%;
		object-fit: cover;
	}

	.ai-name {
		line-height: normal;
	}

	.toggle.on {
		border-color: #ff558d;
		border-radius: 30px;
		background-color: #ff558d;
	}

	.toggle {
		background-color: #999;
		width: 38px;
		height: 22px;
	}

	.toggle-round {
		width: 16px;
		height: 16px;
	}

	.toggle-button {
		margin-top: 0px;
	}

	.ai-thumbnail {
		background-color: white;
	}

	.toggle-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.toggle-wrapper span {
		margin-right: 10px;
		font-weight: 600;
		font-size: 15px;
		color: rgba(191, 189, 189, 1);
	}

	.aichat-section {
		padding-top: 0px;
	}

	.w-tab-menu {
		padding: 10px 0px;
	}

	.tabs-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.category-button {
		margin-top: 10px;
	}

	@media screen and (max-width: 479px) {
		.sort-optoins {
			font-size: 16px;
		}
		.aichat-tab {
			margin-right: 10px;
			padding-left: 10px;
			padding-right: 10px;
		}
		.chat-introduction-popup {
			top: unset;
			left: unset;
			transform: unset;
		}
		.ai-x-button {
			inset: 2.5% 2% auto auto;
		}
		.conversation-bottom {
			padding: 20px 45px 20px;
		}
		.ai-talk-builder {
			inset: auto 5% 5% auto;
		}

		.e-title {
			line-height: 40px;
			font-size: 20px;
			padding-left: 0px;
		}
		.rank {
			font-size: 18px;
			padding: 5px 10px;
		}
		.aichat-section {
			margin-bottom: 24px;
		}
		.ai-contents {
			margin-top: 8px;
		}
	}
</style>
